import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Reveal from '@/components/feature/Reveal';
import { SITE } from '@/config/site';

export default function Terminos() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-20">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <Reveal>
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              Términos y Condiciones
            </h1>
            <p className="mt-4 text-sm text-foreground-500">
              Última actualización: 2026.
            </p>
            <div className="mt-8 space-y-6 text-foreground-500 leading-relaxed">
              <p>
                Al utilizar este sitio web de ACOMA, aceptas los siguientes
                términos y condiciones.
              </p>
              <div>
                <h2 className="text-lg font-semibold font-heading text-foreground-950">
                  Uso del sitio
                </h2>
                <p className="mt-2">
                  El contenido de este sitio tiene fines informativos sobre los
                  servicios y productos de ACOMA. Nos reservamos el derecho de
                  modificar, actualizar o eliminar contenido en cualquier
                  momento.
                </p>
              </div>
              <div>
                <h2 className="text-lg font-semibold font-heading text-foreground-950">
                  Propiedad intelectual
                </h2>
                <p className="mt-2">
                  Todo el contenido, marcas y materiales de este sitio son
                  propiedad de ACOMA y no pueden ser reproducidos sin
                  autorización previa.
                </p>
              </div>
              <div>
                <h2 className="text-lg font-semibold font-heading text-foreground-950">
                  Contacto
                </h2>
                <p className="mt-2">
                  Para consultas sobre estos términos, escríbenos a{' '}
                  <a
                    href={`mailto:${SITE.email}`}
                    className="text-primary-300 hover:text-primary-200"
                  >
                    {SITE.email}
                  </a>
                  .
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
}